/*
 * hojotea custom (MY store): "Read more" collapsible for collection descriptions.
 * Ports the behaviour of shop.hojotea.com (JP store): a `.mwin` trigger opens the
 * inline `#mwin` block in a modaal popup. Uses the jQuery bundled in vendor.js
 * plus modaal.min.js / modaal.css (also copied from the JP theme).
 * Loaded only on the collection template (see layout/theme.liquid).
 */
(function () {
  function init() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.modaal) return;

    var $triggers = $('.mwin').not('.modaal-ready');
    if (!$triggers.length) return;

    var isNarrow = window.matchMedia('(max-width: 1139px)').matches;
    var opts = isNarrow
      ? { fullscreen: true }
      : { type: 'inline', animation_speed: 100 };

    $triggers.addClass('modaal-ready').modaal(opts);

    $('.js-modal-close').off('click.mwin').on('click.mwin', function () {
      $('.mwin').modaal('close');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
